import React from "react";
import ChipSelect from "../../../components/chipSelect";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import NewReleasesOutlinedIcon from "@mui/icons-material/NewReleasesOutlined";
import FieldLabel from "../../../components/label";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Select,
  TextField,
  Stack,
  Typography,
} from "@mui/material";

function EIADetailsForm({
  classes: { accordianSection, contentScroller, formGroup },
  errorMessage,
  form,
  handleAccordionChange,
  handleChange,
  handleChangeChipSelect,
  handleCheckboxChange,
  options,
  section,
  validateInputLength,
}) {
  return (
    <>
      <Box
        className={accordianSection}
        onClick={() => handleAccordionChange("eia", section.eia)}
      >
        <Stack
          direction="row"
          gap={1}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          {!(
            (form.einsurance_account === "Yes" &&
              form.einsurance_account_number) ||
            (form.einsurance_account === "No" &&
              form.einsurance_repository &&
              form.consent)
          ) && <NewReleasesOutlinedIcon sx={{ color: "red" }} />}
          {((form.einsurance_account === "Yes" &&
            form.einsurance_account_number) ||
            (form.einsurance_account === "No" &&
              form.einsurance_repository &&
              form.consent)) && (
            <CheckCircleOutlineIcon sx={{ color: "green" }} />
          )}
          <Typography variant="subtitle2">
            e-Insurance Account Details
          </Typography>
        </Stack>
        <Box>
          {!section.eia && <ExpandMoreIcon fontSize="medium" />}
          {section.eia && <ExpandLessIcon fontSize="medium" />}
        </Box>
      </Box>

      {section.eia && (
        <Box p={1} mt={0} sx={{ height: "420px" }} className={contentScroller}>
          <Box className={formGroup}>
            <FieldLabel label={"Do you have e-Insurance Account?"} />
            <Box display="flex">
              <ChipSelect
                compact={false}
                fontWeight={"regular"}
                fieldname={"einsurance_account"}
                handleChange={handleChangeChipSelect}
                options={options.eiaYesNo}
                selectedItem={form?.einsurance_account}
                isMinWidth={true}
              />
            </Box>
          </Box>

          {form?.einsurance_account === "Yes" ? (
            <Box className={formGroup}>
              <FieldLabel label={"e-Insurance Account Number*"} />
              <TextField
                id="standard-basic"
                variant="outlined"
                value={form.einsurance_account_number}
                name="einsurance_account_number"
                onChange={handleChange}
                onInput={validateInputLength}
                autoComplete="off"
                helperText={errorMessage.einsurance_account_number}
                fullWidth
              />
            </Box>
          ) : (
            <>
              {1 === 2 && (
                <Box className={formGroup}>
                  <FieldLabel
                    label={"Do you want to open e-Insurance Account?"}
                  />
                  <Box display="flex">
                    <ChipSelect
                      compact={false}
                      fontWeight={"regular"}
                      fieldname={"einsurance_account_open"}
                      handleChange={handleChangeChipSelect}
                      options={options.eiaYesNo}
                      selectedItem={form?.einsurance_account_open}
                      isMinWidth={true}
                    />
                  </Box>
                </Box>
              )}
              {form?.einsurance_account_open === "Yes" && (
                <>
                  <Box className={formGroup}>
                    <FormControl variant="outlined" fullWidth>
                      <Box
                        justifyContent="flex-start"
                        display="flex"
                        textAlign="left"
                      >
                        <FieldLabel label={"e-Insurance Repository*"} />
                      </Box>
                      <Box
                        justifyContent="flex-start"
                        display="flex"
                        textAlign="left"
                        fullWidth
                      >
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={form?.einsurance_repository}
                          onChange={handleChange}
                          name="einsurance_repository"
                          fullWidth
                        >
                          {options.eiaRepository.map((option) => {
                            return (
                              <MenuItem
                                key={`education-${option.value}`}
                                value={option.value}
                              >
                                <Typography variant="caption">
                                  {option.title}
                                </Typography>
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </Box>
                    </FormControl>
                  </Box>

                  <Box className={formGroup}>
                    <FormControlLabel
                      control={
                        <Box style={{ alignSelf: "start" }}>
                          <Checkbox
                            checked={form.consent}
                            onChange={handleCheckboxChange}
                            name={"consent"}
                            color="primary"
                            // disabled={true}
                          />
                        </Box>
                      }
                      label={
                        <Box mt={1}>
                          <Typography variant="caption">
                            I give my consent to open an e-Insurance Account.
                          </Typography>
                        </Box>
                      }
                      sx={{ textAlign: "left" }}
                    />
                  </Box>
                </>
              )}
            </>
          )}
        </Box>
      )}
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(EIADetailsForm);
